function e(e) {
  var o = document.cookie.match(new RegExp("(^| )" + e + "=([^;]+)"));
  return !!o && o[2];
}

module.exports = {
  setCookie: function setCookie(e, o, t) {
    void 0 === t && (t = {
      expires: 1,
      in: "days",
      path: "/"
    });
    var i = new Date();
    "hours" === t.in && i.setHours(i.getHours() + t.expires), "days" === t.in && i.setDate(i.getDate() + t.expires), "months" === t.in && i.setMonth(i.getMonth() + t.expires), "years" === t.in && i.setFullYear(i.getFullYear() + t.expires), document.cookie = e + "=" + o + ";expires=" + i.toGMTString() + ";path=" + t.path;
  },
  getCookie: e,
  getAllCookies: function getAllCookies() {
    return document.cookie;
  },
  cookieExists: function cookieExists(o) {
    return void 0 !== e(o);
  },
  removeCookie: function removeCookie(e, o) {
    void 0 === o && (o = {
      path: "/"
    }), document.cookie = e + "=;expires=0;path=" + o.path;
  }
};